/* eslint-disable */
"use strict";

var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_elettronica || process.env.VUE_APP_service_documenti;
})();

async function trasferisciXml(documentoId, nomeFile, link) {
  try {
    const data = {
      documentoId,
      nomeFile,
      link,
    };
    const response = await fetch(`${service}/upload`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
}

async function outFindByUserName(
  username,
  startDate,
  endDate,
  countrySender,
  vatcodeSender,
) {
  try {
    const data = {
      username,
      startDate,
      endDate,
      countrySender,
      vatcodeSender,
    };
    const response = await fetch(`${service}/out/findByUsername`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
}

async function outGetByFilename(filename) {
  try {
    const data = {
      filename,
    };
    const response = await fetch(`${service}/out/getByFilename`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
}

async function inFindByUsername(
  username,
  startDate,
  endDate,
  countryReceiver,
  vatcodeReceiver,
) {
  try {
    const data = {
      username,
      startDate,
      endDate,
      countryReceiver,
      vatcodeReceiver,
    };
    const response = await fetch(`${service}/in/findByUsername`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
}

async function inGetByFilename(filename) {
  try {
    const data = {
      filename,
    };
    const response = await fetch(`${service}/in/getByFilename`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
}

async function inGetInvoiceWithUnsignedFile(invoiceId) {
  try {
    const data = {
      invoiceId,
    };
    const response = await fetch(`${service}/in/getInvoiceWithUnsignedFile`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
}

export default {
  trasferisciXml,
  out_findByUsername: outFindByUserName,
  out_getByFilename: outGetByFilename,
  in_findByUsername: inFindByUsername,
  in_getByFilename: inGetByFilename,
  in_getInvoiceWithUnsignedFile: inGetInvoiceWithUnsignedFile,
};
